import React, { useEffect } from 'react';

import AppView from './App.view';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';
import fr from 'javascript-time-ago/locale/fr.json';
import ru from 'javascript-time-ago/locale/ru.json';
import useRoutes from './utils/hooks/use-routes';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';

// import UnderMaintenancePage from 'applications/retailer/views/UnderMaintenancePage/UnderMaintenancePage';

declare global {
  interface Window {
    _mtm?: Array<Record<string, unknown> | unknown[]>;
  }
}

const App: React.FC = () => {
  const applicationMode = useRoutes();
  const { user } = useSelector((state: RootState) => state.userData);
  const [searchParams] = useSearchParams();

  TimeAgo.addLocale(en);
  TimeAgo.addLocale(ru);
  TimeAgo.addLocale(fr);

  // return <UnderMaintenancePage/>;

  useEffect(() => {
    if (user) {

      const _mtm = (window._mtm = window._mtm || []);

      _mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' });

      const script = document.createElement('script');

      script.async = true;
      script.src = String(process.env.REACT_APP_MATOMO_URL);

      script.onload = () => {
        console.log('Matomo script loaded');

        if (typeof window._mtm !== 'undefined') {
          _mtm.push({
            userId: user.client_id,
            userName: user.client_name,
          });
        }

      };

      script.onerror = () => {
        console.error('Failed to load Matomo script');
      };

      const firstScript = document.getElementsByTagName('script')[0];

      if (firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      }
    }
  }, [user]);

  useEffect(() => {
    const redirectedHref = searchParams.get('authorization_redirected');

    if (redirectedHref && !localStorage.getItem('token') && !localStorage.getItem('clientId')) {
      const urlObj = new URL(window.location.href);

      // Eliminăm parametrul `authorization_redirected`
      urlObj.searchParams.delete('authorization_redirected');

      // Reconstruim path-ul și query-ul fără acel parametru
      const pathAndQuery = urlObj.pathname + urlObj.search;

      localStorage.setItem('redirectedHrefSave', pathAndQuery);
    }
  }, []);


  return <AppView routes={applicationMode} />;
};

App.displayName = 'App';

export default React.memo(App);
